import { render } from "./TopComp.vue?vue&type=template&id=8d745cae"
import script from "./TopComp.vue?vue&type=script&lang=js"
export * from "./TopComp.vue?vue&type=script&lang=js"

import "./TopComp.vue?vue&type=style&index=0&id=8d745cae&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__